const DEFAULT_LOCALE = 'EN';

/**
 * Copied from https://tools.hubteam.com/api-catalog/services/InboundDbPropertiesService-Unified/v4/spec/internal#operations-Property_Group-get-%2Fproperties%2Fv4%2Fgroups%2F%7BobjectType%7D
 */
const SUPPORTED_LOCALES_V4 = ['AF_ZA', 'AR_EG', 'BG', 'BN', 'CA_ES', 'CS', 'DA_DK', 'DE', 'EL_GR', 'EN_GB', 'EN', 'ES_MX', 'ES', 'ET_EE', 'FI', 'FR_CA', 'FR', 'HE_IL', 'HI_IN', 'HR', 'HU', 'ID', 'IT', 'JA', 'KO_KR', 'LT_LT', 'MS', 'NL', 'NO', 'PL', 'PT_BR', 'PT_PT', 'RO', 'RU', 'SK_SK', 'SL', 'SV', 'TH', 'TL', 'TR', 'UK', 'VI_VN', 'ZH_CN', 'ZH_HK', 'ZH_TW'];

/**
 * Extracts the correct user locale supported by the properties endpoint.
 * @param userLocale The current user locale
 */
export function getSupportedLocaleForPropertiesV4(userLocale) {
  if (!userLocale) {
    return DEFAULT_LOCALE;
  }
  let locale = userLocale.toUpperCase();
  if (locale === 'DA') locale = 'DA-DK';
  if (locale === 'KO') locale = 'KO-KR';
  if (SUPPORTED_LOCALES_V4.includes(locale)) {
    return locale;
  }
  const localeUnderscore = locale.replace('-', '_');
  if (SUPPORTED_LOCALES_V4.includes(localeUnderscore)) {
    return localeUnderscore;
  }
  const [lang] = locale.split('-');
  if (SUPPORTED_LOCALES_V4.includes(lang)) {
    return lang;
  }
  return DEFAULT_LOCALE;
}